(function() {
  'use strict';

  /**
   * The custom partials paths.
   * @type {Object}
   */
  var paths = {
    titleTemplateUrl: 'app/components/dashboard/partials/dashboard-title.html',
    editTemplateUrl: 'app/components/dashboard/partials/dashboard-edit.html',
    addTemplateUrl: 'app/components/dashboard/partials/dashboard-addwidget.html',
    widgetTitleUrl: 'app/components/dashboard/partials/widget-title.html'
  };

  /**
   * This is the default dashboard template layout.
   * @type {Object}
   */
  var layout = {
    structure: '3-5-4',
    rows: [
      {
        columns: [
          {
            styleClass: 'col-sm-3',
            widgets: []
          },
          {
            styleClass: 'col-sm-5',
            widgets: []
          },
          {
            styleClass: 'col-sm-4',
            widgets: []
          }
        ]
      }
    ]
  };

  /**
   * This is the default dashboard template. It relies on the layout and extends it.
   * @type {Object}
   */
  var template = _.cloneDeep(layout);
  template.title = 'Profile';
  template.rows[0].columns[0].widgets.push({
    title: 'Profile',
    type: 'userProfile',
    titleTemplateUrl: paths.widgetTitleUrl,
    config: {
      options: {
        hideTitle: true
      }
    }
  });

  template.rows[0].columns[1].widgets.push({
    title: 'Create a new event',
    type: 'newEvent',
    titleTemplateUrl: paths.widgetTitleUrl
  });

  angular.module('component.dashboardTemplates')
    .constant('PROFILE_PARTIALS_PATHS', paths)
    .constant('DEFAULT_PROFILE_TEMPLATE', template)
    .constant('DEFAULT_PROFILE_TEMPLATE_LAYOUT', layout);
})();
